/* SCOUT 2026-09-27 (Dani, cart-drawer perf): dropped from 300ms to 120ms.
   300ms was the Dawn default and it stacked on top of iOS touch delay so + / −
   in the cart drawer felt broken on the first touch — the coalesced call
   also swallowed rapid taps. 120ms still coalesces genuine double-taps
   into one network call without feeling laggy. */
const ON_CHANGE_DEBOUNCE_TIMER = 120;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
